import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { BuildTalents, getDefaultName, sortCities } from '../utils'
import { loadCities } from '../utils/Network'
import { getUsersFilterSelectStyles, makeDarkSelectStyles } from './selectStyles';

export default function SelectCities({ callback, country, value, width, name, usersFilter, placeholder, border }) {

    const [SelectOptions, setSelectOptions] = useState([]);

    const customStyles = usersFilter
        ? getUsersFilterSelectStyles({ width: width || '190px', border: 1 })
        : makeDarkSelectStyles({ width: width || '190px', border });


    useEffect(() => {
        if (country){
            loadCities(country).then(data => {
                if (data.results) {
                    var cities = data.results
                    sortCities(cities)
                    var temp_options = []
                    cities.map((item, i) => {
                        var option = null;
                        option = {
                            label: getDefaultName(item.names),
                            value: item.id
                        }
                        temp_options.push(option)
                    })
                    //
                    setSelectOptions(temp_options);
                    // callback()
                    //setTalents(temp)
                }

            })
        }
            
    }, [])

    const handleSelect = (e) => {
        if(e){
            var value = e.value;
            callback(value, name)
        }
        else{
            callback(null, name)
        }

    }

    return (
        <>
            <div className="filter-select">
                <Select
                    options={SelectOptions}
                    styles={customStyles}
                    onChange={handleSelect}
                    placeholder={placeholder || "City"}
                    isClearable={true}
                    value={SelectOptions && SelectOptions.filter(obj => obj.value == value)}
                    menuPortalTarget={usersFilter ? document.body : undefined}
                    menuPosition={usersFilter ? 'fixed' : undefined}
                />
            </div>

        </>
    )
}
